import { usePartnerIntegrationAccountName } from '../partnerIntegrationSlice';

export const AccountInfo = () => {
    const accountName = usePartnerIntegrationAccountName();

    return (
        <>
            <h2>Account Info</h2>
            <p data-cy='partner-integration-page-account-info'>Name: {accountName && <strong>{accountName}</strong>}</p>
        </>
    );
};
